export default "__VITE_ASSET__DbFnl$SC__"